module.exports = __webpack_public_path__ + "img/26.cb3adf09.jpg";